export const initialsOf = ({ firstName, lastName }: { firstName: string; lastName: string }) =>
  `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
